import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import ModalDelete from './ModalDelete';
import Button from '../../app2/Components/ComponentButton';
function ButtonDelete({ document, children, classes }) {
    const [showModal, setShowModal] = useState(false);
    return (_jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ id: 'delete-document', onClick: () => setShowModal(true), classes: classnames('tailwind-reset', classes) }, { children: children })), showModal && (_jsx(ModalDelete, { document: document, onClose: () => setShowModal(false) }))] }));
}
ButtonDelete.propTypes = {
    document: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
    classes: PropTypes.string
};
export default ButtonDelete;
